import { render, staticRenderFns } from "./PrtMaterialDetail.vue?vue&type=template&id=f94536c2&scoped=true"
import script from "./PrtMaterialDetail.vue?vue&type=script&lang=js"
export * from "./PrtMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./PrtMaterialDetail.vue?vue&type=style&index=0&id=f94536c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94536c2",
  null
  
)

export default component.exports